module.exports = __webpack_public_path__ + "img/bio-mobile.68e1df9a.jpg";